// Module
var code = `<div class="mis-tree">
  <ent tree-data="\$ctrl.availableMisGroups"
       select-only-leaves="true"
       node-label="\$ctrl.label"
       search="true"
       ng-required="\$ctrl.ngRequired"
       ng-change="\$ctrl.onMisGroupChange()"
       ng-disabled="\$ctrl.ngDisabled"
       ng-model="\$ctrl.misGroup">
  </ent>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/loan/loan-mis-group.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;